import { repositoryPos } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";

/** Các giá trị attribute3 đang có trong danh mục kho (không trùng lặp), để chọn ở cột "Thuộc tính" */
export const getDistinctAttribute3 = async (): Promise<string[]> => {
  const res = await repositoryPos.get<MessageResponse<string[]>>(
    `/api/v1/TblDmInventory/get-distinct-attribute3`,
  );
  return res?.success ? res.data : [];
};

/** Lưu attribute3 (null = xoá giá trị) cho một kho trong danh mục kho */
export const updateInventoryAttribute3 = (
  inventoryId: string,
  attribute3: string | null,
) =>
  repositoryPos.post<MessageResponse<boolean>>(
    `/api/v1/TblDmInventory/update-attribute3`,
    { id: Number(inventoryId), attribute3 },
  );
